export default __webpack_public_path__ + "static/media/CDUAcuteCardio-RespiratoryPathwayUHLEMAScardio-respCDUdirectalgo-18.e72b90b8.jpg";